import { render, staticRenderFns } from "./NodeErrorView.vue?vue&type=template&id=b6b58e3a"
import script from "./NodeErrorView.vue?vue&type=script&lang=ts"
export * from "./NodeErrorView.vue?vue&type=script&lang=ts"
import style0 from "./NodeErrorView.vue?vue&type=style&index=0&id=b6b58e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports